import FavoritesSection from "./comps/FavoritesSection";

export default function Favoritter() {
	return <div>
		<h1>Favoritter</h1>

		{/*<MyFavourites/>*/}

		<FavoritesSection maxPerRow={3}/>

	</div>
}